import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { decrypt } from "../../../../utils/Encrypt";
import { hasPermission } from "../../../../utils/myFunctions"; 
import { Badge } from "reactstrap";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, Icon } from "../../../../components/Component";
import Head from "../../../../layout/head/Head";
import Content from "../../../../layout/content/Content";
import { useForm } from "react-hook-form";
import ApiPaginationDataTable from "../../../../myComponents/DataTable/ApiPaginationDataTable";
import { getNodalCenterListAPI } from "../../../../api/LMS/master";
import useLogout from "../../../../hooks/useLogout";
import { toast } from "react-toastify";
import { getApprovedStudentListAPI, getTotalStudentListAPI } from "../../../../api/LMS/lmsdashboard";

const ApprovedStudent = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const enc = JSON.parse(localStorage.getItem("userDetail"));
  const user = decrypt(enc?.data || []);
  console.log("user", user);
  const isView = hasPermission(user, location?.pathname, "isView");
  const isUpdate = hasPermission(user, location?.pathname, "isUpdate");
  const isDelete = hasPermission(user, location?.pathname, "isDelete");
  const isCreate = hasPermission(user, location?.pathname, "isCreate");
  const [timer, setTimer] = useState(5); // 5 seconds countdown
  // useEffect(() => {
  //   if (!isView) {
  //     const interval = setInterval(() => {
  //       setTimer((prevTimer) => prevTimer - 1);
  //     }, 1000);
  //     // redirect to home page when the timer reaches 0
  //     if (timer === 0) {
  //       navigate(-1);
  //     }
  //     // clean up the interval when the component unmounts
  //     return () => clearInterval(interval);
  //   } else {
  //     setIsLoading(false);
  //   }
  // }, [timer]);
  const logout = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      status: null, 
      server_search:"",
    },
  });
  const [data, setData] = useState([]);
  const [classList, setClassList] = useState([]);
  const [column, setColumn] = useState([
    {
      name: "Division",
      selector: (row) => row?.division_name,
      sortable: true,
      wrap:true
    },
    {
      name: "District",
      selector: (row) => row?.district_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Center Name",
      selector: (row) => row?.center_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Center Code",
      selector: (row) => row?.center_code,
      sortable: true,
      wrap: true,
    }, 
    {
      name: "Student Name",
      selector: (row) => row?.name,
      sortable: true,
      wrap:true
    },
   {
      name: "Class",
      selector: (row) => row?.class_name,
      sortable: true,
      wrap: true,
    },
   
   

    {
      name: "Status",
      selector: (row) => row?.student_status,
      cell: (row) => (
        <div   >
          <Badge color={`${row.student_status?  "success" : "danger"}`}>
            {row.student_status ? "Active" : "Inactive"}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
  
  ]);
  //pagination
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(20);
  // pagination
  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(newPerPage) ? totalRows : newPerPage;
    setPerPage(rows);
    setValue("page", page);
  };
  const handlePageChange = (page) => {
    setValue("page", page);
  };
  useEffect(() => {
    if (watch("server_search")?.length == 0) {
      handleSearch(perPage);
    }
  }, [watch("page"), perPage,watch("server_search")]);
  const handleSearch = (data) => {
    console.log("data", data);
    const payload = {  
      limit: perPage,
      page: watch("page") || 1,
    };
    setIsLoading(true);
    getApprovedStudentListAPI(payload)
      .then((res) => {
        const status = res.data.status;
        if (status===true) { 
          setTotalRows(res.data.data.totalRecords);
          setData(res.data.data.data);
          setIsLoading(false);
        } else if (status===false) {
          setData([]);
          setIsLoading(false);
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Err", err);
      });
  };
  const serverSideSearch = (data) => {
    const body = {
      search: data,
    }; 
    getApprovedStudentListAPI(body)
      .then((res) => {
        const status = res.data.status;
        if (status===true) {
          setIsLoading(false);
          setData(res.data.data.data);
        } else if (status===false) {
          setIsLoading(false);
          setData([]);
        } else if (status === "expired") {
          setIsLoading(false);
          logout();
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("catch error", err);
      });
  }; 
  return (
    <>
      <Head title={"Total Approved Students | LMS Dashboard"} />
      <Content>
        {/* {!isView ? (
          <div className="p-5" style={{}}>
            <p style={{ color: "crimson", textAlign: "center" }}>{"Unauthorized"}</p>
            <p style={{ textAlign: "center" }}>
              You will be redirected to the home page in <b style={{ color: "crimson" }}>{timer} </b> seconds.
            </p>
          </div>
        ) :<></>} */}

        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Total Approved Students"}
              </BlockTitle>
            </BlockHeadContent>
             <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <div className="toggle-expand-content">
                  <ul className="nk-block-tools g-3">
                    <li className="nk-block-tools-opt">
                      <Button
                        size={"xs"}
                        color={`primary`}
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        <Icon className={`me-1`} name={`arrow-left`} />
                        {"Back"}
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>{" "}
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <ApiPaginationDataTable
            columns={column}
            data={data}
            isLoading={isLoading}
            register={register}
            trigger={trigger}
            watch={watch}
            setValue={setValue}
            title={"Students List"}
            errors={errors}
            serverSearch
            handleSubmit={handleSubmit}
            handleSearch={handleSearch}
            serverSideSearch={serverSideSearch}
            handlePerRowsChange={handlePerRowsChange}
            handlePageChange={handlePageChange}
            totalRows={totalRows}
            perPage={perPage}
          />
        </Block>
      </Content>
    </>
  );
};

export default ApprovedStudent;
